import { render, staticRenderFns } from "./WatchVideoSection.vue?vue&type=template&id=fca3ae82&scoped=true&"
import script from "./WatchVideoSection.vue?vue&type=script&lang=js&"
export * from "./WatchVideoSection.vue?vue&type=script&lang=js&"
import style0 from "./WatchVideoSection.vue?vue&type=style&index=0&id=fca3ae82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca3ae82",
  null
  
)

export default component.exports